function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import React from 'react';
import ReactMarkdown from 'react-markdown';
import Link from 'shared/components/Link';
import { environment } from 'shared/helper/environment';
import { translate } from '../util';
import ChildComponentParser from './ChildComponentParser';
var env = environment();
var Translate = /*#__PURE__*/function (_React$PureComponent) {
  function Translate() {
    _classCallCheck(this, Translate);
    return _callSuper(this, Translate, arguments);
  }
  _inherits(Translate, _React$PureComponent);
  return _createClass(Translate, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        _this$props$className = _this$props.className,
        className = _this$props$className === void 0 ? '' : _this$props$className,
        inline = _this$props.inline,
        linkRenderer = _this$props.linkRenderer,
        markdownify = _this$props.markdownify,
        _this$props$params = _this$props.params,
        params = _this$props$params === void 0 ? {} : _this$props$params,
        source = _this$props.source,
        translations = _this$props.translations,
        useLink = _this$props.useLink;
      var translatedString = translate(source, params, translations);
      var title = env !== 'production' ? source : undefined;
      var link = linkRenderer;
      if (!link) {
        link = function link(_ref) {
          var href = _ref.href,
            children = _ref.children;
          return useLink && href.indexOf('mailto') === -1 ? /*#__PURE__*/React.createElement(Link, {
            to: href,
            className: "skip-tracking"
          }, children) : /*#__PURE__*/React.createElement("a", {
            href: href
          }, children);
        };
      }
      var html = function html(_ref2) {
        var value = _ref2.value;
        return /*#__PURE__*/React.createElement(ChildComponentParser, {
          value: value,
          params: params
        });
      };
      var renderers = inline ? {
        root: function root(_ref3) {
          var children = _ref3.children;
          return /*#__PURE__*/React.createElement("span", {
            className: className
          }, children);
        },
        paragraph: function paragraph(_ref4) {
          var children = _ref4.children;
          return /*#__PURE__*/React.createElement("span", null, children);
        },
        link: link,
        html: html
      } : {
        link: link,
        html: html
      };

      // If it's html or isn't being markdown'd, just render it
      if (/<([a-z][a-z0-9]*)\b[^>]*>/.test(translatedString) || /&[a-z]*;/.test(translatedString) || !markdownify) {
        // We're disabling eslint for this line, because translations can have html and/or markdown
        // eslint-disable-next-line react/no-danger
        return /*#__PURE__*/React.createElement("span", {
          title: title,
          dangerouslySetInnerHTML: {
            __html: translatedString
          }
        });
      }
      return /*#__PURE__*/React.createElement("div", {
        className: "p-0 m-0 d-inline",
        title: title
      }, /*#__PURE__*/React.createElement(ReactMarkdown, {
        className: className,
        escapeHtml: false,
        renderers: renderers,
        source: translatedString
      }));
    }
  }]);
}(React.PureComponent);
export default Translate;